import { render, staticRenderFns } from "./SocialNetworks.vue?vue&type=template&id=502a35ff&scoped=true"
import script from "./SocialNetworks.vue?vue&type=script&lang=js"
export * from "./SocialNetworks.vue?vue&type=script&lang=js"
import style0 from "./SocialNetworks.vue?vue&type=style&index=0&id=502a35ff&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502a35ff",
  null
  
)

export default component.exports